export { SectionHeading } from './SectionHeading';
export type {
  SectionHeadingProps,
  SectionHeadingButton,
  SectionHeadingButtonGroupItem,
} from './SectionHeading';
